import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-transaction-status-change-confirm',
  templateUrl: './transaction-status-change-confirm.component.html',
  styleUrls: ['./transaction-status-change-confirm.component.scss']
})
export class TransactionStatusChangeConfirmComponent implements OnInit {
  message: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
     const raw = this.config.data.message || '';
     this.message = raw
      .replace(/ /g, '&nbsp;')
      .replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  accept() {
    this.ref.close(true);
  }

  reject() {
    this.ref.close(false);
  }
}
